<template>
  <div class="helpAppointContainer">
    <div class="infoBlock">
      <div class="blockForm">
        <!-- <span class="value">{{ appointState.hospitalName }}</span> -->
        <div class="hospital_list">
          <span class="label">就诊医院：</span>
          <a-select
            :value="activeItem.hospitalId"
            :bordered="false"
            style="width: 296px"
            @change="handleChange"
          >
            <a-select-option
              v-for="item in hospitalList"
              :key="item.hospitalId"
              :value="item.hospitalId"
            >
              {{ item.hospitalName }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div class="blockForm">
        <span class="label">就诊医生：</span>
        <span class="value">{{ appointState.username }}</span>
      </div>
      <div class="blockForm">
        <span class="label">就诊科室：</span>
        <span class="value">{{ appointState.doctorDepartmentName }}</span>
      </div>
    </div>
    <a-divider style="margin: 20px 0 0 0" />
    <div class="infoBlock">
      <PatientProfilePicker
        :ucPatientId="patientInfo.ucUserId"
        :ucDoctorId="doctorInfo.ucUserId"
        :businessType="8"
        @handleSelect="handleSelect"
      />
      <div class="timeLabel">就诊时间</div>
      <div class="warnInfo">
        <div>1. 可以预约当日及未来两周的号；</div>
        <div>2. 就诊时间先与患者、医生双方确认无误后再提交预约单；</div>
        <div>3. 线上预约后患者还需到医院门诊进行正常挂号缴费，具体流程提前与患者沟通确认。</div>
      </div>
      <a-spin :spinning="spinning">
        <div class="timeBlock" v-if="reverseDate && reverseDate.length">
          <div
            v-for="(time, index) in reverseDate"
            :class="['clickTimeItem', activeIndex === index ? 'active' : '']"
            :key="index"
            @click="selcetTime(time, index)"
          >
            <!-- <div class="resource full" v-if="time.isFull">已满</div>
            <div class="resource" v-if="!time.isFull && activeIndex !== index">
              {{ time.count + '/' + time.registerLimit }}
            </div> -->
            <auth-img
              v-if="activeIndex === index"
              class="checkSign"
              src="@/assets/img/date-check.png"
              alt=""
            />
            <span>{{ time.reserveDateStr }}</span>
          </div>
        </div>
        <div class="empty" v-else>
          <auth-img src="@/assets/img/empty.png" mode="scaleToFill" />
          <span>暂无可预约时间</span>
        </div>
      </a-spin>
    </div>
  </div>
  <div :style="footerStyle">
    <a-button style="margin-right: 8px" @click="emits('onclose')">取消</a-button>
    <a-button type="primary" :disabled="!reverseDate.length" @click="confirmAppoint">
      确认预约
    </a-button>
  </div>
  <ModalTips @on-ok="checkDoctorAppoint" ref="ModalTipsDOM"></ModalTips>
</template>

<script setup>
import ModalTips from './ModalTips.vue'
import { useStore } from 'vuex'
import { onMounted, defineEmits, reactive, ref, computed, createVNode } from 'vue'
import {
  getV2AppointDate,
  submitAppoint,
  preBaseAppointInfo,
  queryExistCureReserve
} from '@/api/workPlace/appoint'
import { Modal, notification, message } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { inputRule } from '@/utils/validate'
import { checkReserveFlag } from '@/api/workPlace/appoint'
import { getOutPatientList } from '@/api/chat'
import PatientProfilePicker from '@/components/PatientProfilePicker'
const footerStyle = {
  left: 0,
  bottom: 0,
  width: '100%',
  background: '#fff',
  textAlign: 'right',
  padding: '10px 16px',
  position: 'absolute',
  borderRadius: '0 0 4px 4px',
  borderTop: '1px solid #e8e8e8'
}
const emits = defineEmits(['onclose', 'onAppointCb'])
const appointState = reactive({
  patientName: '',
  patientPhone: '',
  reserveDate: '',
  reserveDateStr: '',
  username: '',
  // hospitalName: '',
  doctorDepartmentName: ''
})
const patientProfileId = ref()

const appointRules = {
  patientName: [
    {
      required: true,
      message: '请输入就诊人姓名',
      trigger: 'blur'
    }
  ],
  patientPhone: [
    {
      required: true,
      message: '请输入就诊人手机号',
      trigger: 'blur'
    }
  ]
}

function inputR(e, key, type) {
  appointState[key] = inputRule(e.target.value, type)
}

const activeIndex = ref(null)
const selcetTime = (ctx, index) => {
  // if (ctx.isFull) return
  activeIndex.value = index
  appointState.reserveDate = ctx.reserveDate
  appointState.reserveDateStr = ctx.reserveDateStr
}

const store = useStore()
const curOrder = computed(() => store.state.workOrder.workOrderGroupInfo)
const doctorInfo = curOrder.value.doctorInfo
const patientInfo = curOrder.value.patientInfo
const renderBaseInfo = () => {
  return new Promise(resolve => {
    // appointState.hospitalName = doctorInfo.hospitalName
    appointState.username = doctorInfo.username
    appointState.doctorDepartmentName = doctorInfo.doctorDepartmentName
    resolve({
      ucDoctorId: doctorInfo.ucUserId,
      ucPatientId: patientInfo.ucUserId
    })
  })
}

const reverseDate = ref([])
const spinning = ref(false)
const getReverseDate = () => {
  spinning.value = true
  getV2AppointDate({
    queryType: 1,
    doctorId: doctorInfo.businessId,
    hospitalId: activeItem.value.hospitalId
  })
    .then(res => {
      reverseDate.value = res || []
    })
    .finally(() => {
      spinning.value = false
    })
}

const paramsState = ref({})
onMounted(() => {
  renderBaseInfo().then(ctx => {
    preBaseAppointInfo(ctx).then(res => {
      const { patientName, patientPhone, ucDoctorId, ucPatientId } = res
      appointState.patientName = patientName
      appointState.patientPhone = patientPhone
      paramsState.value = {
        ucDoctorId,
        ucPatientId
      }
    })
  })
  getHospitalList()
})

const checkDoctorAppoint = () => {
  checkReserveFlag({ doctorId: doctorInfo.businessId }).then(res => {
    if (res) {
      submitAppointForm()
    } else {
      emits('onAppointCb')
    }
  })
}
const ModalTipsDOM = ref()
const formRef = ref()
const confirmAppoint = async () => {
  const params = {
    ucDoctorId: paramsState.value.ucDoctorId,
    ucPatientId: paramsState.value.ucPatientId,
    reserveDate: appointState.reserveDate
  }
  // 确定提交钱的二次确认
  queryExistCureReserve(params)
    .then(result => {
      if (result) {
        // revisitType  1 线上问诊 2 门诊就诊
        // reserveDateDetail 1：上午  2：下午
        const { reserveDateStr, revisitType, reserveDateDetail } = result
        // INFO:什么时间段 (TI => time interval)
        const curTI = () => {
          const ti = reserveDateDetail === 1 ? '上午' : '下午'
          return reserveDateStr + ' ' + ti
        }
        const newsTI = () => {
          const date = appointState.reserveDate.split(' ')[0] || ''
          let ti = ''
          const isAM = appointState.reserveDateStr.includes('上午')
          const isPM = appointState.reserveDateStr.includes('下午')
          if (isAM) {
            ti = '上午'
          } else if (isPM) {
            ti = '下午'
          }
          return date + ' ' + ti
        }
        const data = {
          news: {
            method: '门诊就诊',
            date: newsTI()
          },
          cur: {
            method: revisitType === 1 ? '线上问诊' : '门诊就诊',
            date: curTI()
          }
        }
        ModalTipsDOM.value.onOpen(data)
      } else {
        checkDoctorAppoint()
      }
    })
    .catch(err => {
      notification.error({
        message: err,
        duration: 5
      })
    })
}

const submitAppointForm = () => {
  if (!appointState.reserveDate) {
    return notification.warning({ message: '请选择就诊时间！', duration: 1 })
  }
  Modal.confirm({
    centered: true,
    title: '提示',
    icon: createVNode(ExclamationCircleOutlined),
    content: '已与患者、医生沟通并确认时间？',
    okText: '是',
    cancelText: '否',
    onOk: () => {
      submitAppoint({
        patientName: appointState.patientName,
        patientPhone: appointState.patientPhone,
        reserveDate: appointState.reserveDate,
        ...paramsState.value,
        modifyReserveDateFlag: 1,
        reserveEntry: 4,
        hospitalName: activeItem.value.hospitalName,
        hospitalId: activeItem.value.hospitalId,
        patientProfileId: patientProfileId.value || patientInfo.ucUserId
      }).then(() => {
        message.success('预约成功！')
        emits('onclose')
      })
    }
  })
}
// 获取医生所有职业点
const hospitalList = ref([])
const activeItem = ref({}) // 当前选中的职业点

const getHospitalList = () => {
  doctorInfo.ucUserId &&
    getOutPatientList({
      ucDoctorId: doctorInfo.ucUserId
    })
      .then(result => {
        hospitalList.value = result || []
        activeItem.value = hospitalList.value[0] || {}
        getReverseDate()
      })
      .catch(err => {
        hospitalList.value = []
        activeItem.value = {}
      })
}
// 切换机构
const handleChange = value => {
  const item = hospitalList.value.find(item => item.hospitalId === value) || {}
  activeItem.value = item
  getReverseDate()
}

// 选择就诊人
const handleSelect = patientInfo => {
  patientProfileId.value = patientInfo.patientProfileId
}
</script>
<style lang="scss" scoped>
.helpAppointContainer {
  padding-bottom: 80px;

  ::v-deep(.ant-form-item-label) {
    padding-bottom: 6px !important;
  }

  .infoBlock {
    .blockForm {
      margin-bottom: 20px;
      font-size: 14px;
      color: #333333;

      .label {
        display: inline-block;
        text-align: right;
        color: #999999;
      }

      .value {
        font-weight: 500;
      }
      .hospital_list {
        ::v-deep(.ant-select) {
          .ant-select-arrow {
            color: #333333;
          }
        }
      }
    }

    .warnInfo {
      margin: 4px 0;
      color: #999999;
      font-weight: 500;
      font-size: 12px;
    }

    .timeLabel {
      margin-top: 20px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
    }

    .timeLabel::before {
      color: #ff4d4f;
      font-weight: normal;
      font-size: 14px;
      font-family: SimSun, sans-serif;
      content: '*';
      margin-right: 4px;
    }

    .timeBlock {
      padding-top: 6px;
      display: flex;
      flex-wrap: wrap;

      .clickTimeItem {
        width: 258px;
        text-align: center;
        line-height: 60px;
        background: #f5f5f5;
        border-radius: 4px;
        margin-bottom: 16px;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        border: 1px solid #f5f5f5;
        cursor: pointer;
        position: relative;
      }

      .clickTimeItem:nth-of-type(odd) {
        margin-right: 20px;
      }

      .active {
        background: #1890ff14;
        border: 1px solid #1890ff;
      }

      .disabled {
        cursor: not-allowed;
        color: #3333334d;
      }

      .checkSign {
        width: 24px;
        height: 22px;
        position: absolute;
        bottom: -2px;
        right: -1px;
      }

      .resource {
        position: absolute;
        right: -1px;
        top: -1px;
        width: 40px;
        line-height: 20px;
        border-radius: 10px 4px 10px 10px;
        font-weight: 500;
        font-size: 12px;
        color: #999999;
        border: 1px solid #00000024;

        .full {
          color: #bababa;
          font-size: 10px;
          border: 1px solid #0000001a;
        }
      }
    }

    .empty {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        width: 200px;
        height: 200px;
      }

      span {
        margin-top: 17px;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
</style>
